import React, { useContext, useEffect, useRef, useState } from 'react'
import './Login.css'
import Text from '../../components/text/Text'
import { useLoadingContext } from '../../context/spinnerContext'
// import { link } from './../../components/text/Text'
import { loginUserMantenedor } from '../../services/authentication'

import {
    useAuthDispatch,
    useAuthState,
} from '../../context/loginContext/loginContext'
import { useNavigate } from 'react-router-dom'
import ModalComponent from '../../components/modal/ModalComponent'
import IncorrectCredentials from '../../components/modal/modalVariants/IncorrectCredentials'
import { clevertapEvents, labels } from '../../labels'
import { format } from 'date-fns'

import {
    getBrands,
    getCategories,
    getCategoriesByCommerce,
} from '../../services/products'
import { logIn, track } from '../../ClevertapWrapper'
import { FeatureContext } from '../../context/useFeatureFlagContext'
import { getFeatureFlags } from '../../services/commerce'
import InputComponent from '../../components/input/InputComponent'
import CarouselComponent from '../../components/Carrousel/CarouselComponent'

import User from './../../assets/icons/icon-user.png'
import Lock from './../../assets/icons/icon-lock.png'
// import Help from './../../assets/icons/help-desk-button.png'
// import SquareCheckBox from '../../components/checkBox/SquareCheckBox'
import error from '../../assets/icons/icons-error.svg'

// const acceptTerms = localStorage.getItem('acceptTerms') === 'true'
interface ILoginFormErrors {
    commerceCode: string
    password: string
    user: string
}

const formInputs: ILoginFormErrors = {
    commerceCode: 'commerceCode',
    password: 'password',
    user: 'user',
}

export default function LoginMantenedor() {
    // const [accept, setAccept] = useState<boolean>(!!acceptTerms)
    const formDataRef = useRef<FormData | null>(null)
    const loadingContext = useLoadingContext()

    const { updateFeature } = useContext(FeatureContext)

    const [errors, setErrors] = useState<ILoginFormErrors>({
        commerceCode: '',
        password: '',
        user: '',
    })
    const dispatch = useAuthDispatch()
    const navigate = useNavigate()
    const user = useAuthState()

    const [loginCount, setLoginCount] = useState<number>(0)
    const [modalContentType, setModalContentType] =
        React.useState<ContentType>(null)
    const [lat, setLat] = useState<number>(0)
    const [lng, setLng] = useState<number>(0)

    const data1 = {
        success: true,
    }
    const data2 = {
        error: true,
    }

    const noLoginData = {
        pageName: 'Login',
        url: window.location.href,
        geoLocationLat: lat,
        geoLocationLong: lng,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
    }

    const getLocation = () => {
        navigator.geolocation.getCurrentPosition((position) => {
            setLat(position.coords.latitude)
            setLng(position.coords.longitude)
        })
    }
    const handleOpenErrorModal = (type: ContentType) => {
        setModalContentType(type)
    }

    const handleCloseErrorModal = () => {
        setModalContentType(null)
    }

    const formValidation = (data: FormData) => {
        let isValid = true
        if (!data.get(formInputs.commerceCode)) {
            setErrors((prevState) => ({
                ...prevState,
                [formInputs.commerceCode]: 'Codigo de comercio requerido',
            }))
            isValid = false
        }
        if (!data.get(formInputs.user)) {
            setErrors((prevState) => ({
                ...prevState,
                [formInputs.user]: 'Usuario requerido',
            }))
            isValid = false
        }
        if (!data.get(formInputs.password)) {
            setErrors((prevState) => ({
                ...prevState,
                [formInputs.password]: 'Clave requerida',
            }))
            isValid = false
        }
        return isValid
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        track(clevertapEvents.amiposweb_login, noLoginData)
        event.preventDefault()

        dispatch({
            type: 'REQUEST_LOGIN',
            error: '',
            payload: { user: null, auth_token: '' },
        })
        const data = new FormData(event.currentTarget)
        formDataRef.current = data
        const geo = navigator.geolocation.getCurrentPosition(() => print)
        const loginDate = new Date()

        if (formValidation(data)) {
            loadingContext?.onOpen()

            await loginUserMantenedor(
                data.get('commerceCode') as string,
                data.get('user') as string,
                data.get('password') as string
            ).then(async (response) => {
                if (response == null) {
                    loadingContext?.onClose()
                    track('web- Error al iniciar sesión', data2)
                    setLoginCount((prevState) => prevState + 1)
                    handleOpenErrorModal('error')
                }

                if (response?.status === 200) {
                    const responseData: ICommerceBO = JSON.parse(
                        await response.text()
                    )

                    // const isPilot = responseData.cLocal.some(
                    //     (local) => local.isPilot
                    // )

                    // if (!isPilot) {
                    //     alert(
                    //         'No puede iniciar sesión ya que el comercio no es parte del piloto.'
                    //     )
                    //     loadingContext?.onClose()
                    //     return
                    // }

                    track('web- Sesión iniciada exitosamente', data1)

                    track(clevertapEvents.loginEvent, labels.commerceCode)

                    logIn({
                        Identity: data.get('commerceCode'),
                        Email: responseData.sEmailContacto,
                        Site: {
                            geolocation: geo,
                            login: loginDate,
                        },
                    })

                    localStorage.setItem('isAdmin', `${responseData.bAdmin}`)

                    const loginSuccessAction: ILoginAction = {
                        type: 'LOGIN_SUCCESS',
                        error: '',
                        payload: {
                            user: responseData,
                            auth_token: responseData.token,
                        },
                    }

                    dispatch(loginSuccessAction)

                    const localData = JSON.stringify(responseData)

                    localStorage.setItem('currentUser', localData)
                    localStorage.setItem(
                        'commerceCode',
                        data.get('commerceCode') as string
                    )
                    localStorage.setItem('acceptTerms', 'true')

                    track(clevertapEvents.amiposweb_login_operaciones, {
                        ...noLoginData,
                        email: data.get('user'),
                    })

                    track(clevertapEvents.amiposweb_pageload, {
                        ...noLoginData,
                        rut: responseData.sRut,
                        cc: data.get('commerceCode'),
                        comercio: responseData.sNombre,
                        email: responseData.sEmailContacto,
                    })

                    await getBrands()
                    await getCategories()
                    if (!responseData.bAdmin) {
                        await getCategoriesByCommerce()
                    }

                    getFeatureFlags().then((res) => {
                        loadingContext?.onClose()
                        updateFeature(res)
                        navigate('/')
                    })
                } else {
                    loadingContext?.onClose()
                    track('web- Error al iniciar sesión', data2)
                    setLoginCount((prevState) => prevState + 1)
                    handleOpenErrorModal('error')
                }
            })
        }
    }

    useEffect(() => {
        if (loginCount > 3) {
            setLoginCount(1)
        }
    }, [loginCount])

    useEffect(() => {
        if (user.token) {
            navigate('/')
        }
    }, [])

    useEffect(() => {
        getLocation()
    }, [lat, lng])

    useEffect(() => {
        track(clevertapEvents.pageLoadNoLogin, noLoginData)
    }, [])

    useEffect(() => {
        localStorage.removeItem('selectedLocal')
    }, [])

    // const handlePressForgotPassword = () => {
    //     track("web- Click en 'Olvide Contraseña'", data1)
    // }
    const swiperData = [
        {
            image: require('./../../assets/icons/swipe-image-1.png'),
            title: 'ATRAE MÁS CLIENTES',
        },
        {
            image: require('./../../assets/icons/swipe-image-2.png'),
            title: 'ADMINISTRA TU NEGOCIO',
        },
        {
            image: require('./../../assets/icons/swipe-image-3.png'),
            title: 'COBRA FÁCIL',
        },
        {
            image: require('./../../assets/icons/swipe-image-4.png'),
            title: 'IMPULSA TUS VENTAS',
        },
    ]

    return (
        <>
            <div className="cLoginContainer">
                <div className="cLoginContent">
                    <div className="cLoginCarrusel">
                        <CarouselComponent data={swiperData} />
                    </div>
                    <div className="cLoginFormulario">
                        <div className="login">
                            <form
                                className="loginform"
                                onSubmit={handleSubmit}
                                noValidate
                            >
                                <div className="login-title">
                                    <Text
                                        label={labels.loginTitle}
                                        fontSize={24}
                                        fontWeight={500}
                                        color={'#006BAB'}
                                    />
                                </div>

                                <InputComponent
                                    className="inputLoginContent"
                                    floatingLabel={labels.commerceCode}
                                    placeholder="0000000"
                                    formId="commerceCode"
                                    error={errors.commerceCode}
                                    img={User}
                                />
                                <InputComponent
                                    className="inputLoginContent"
                                    floatingLabel={labels.user}
                                    placeholder="Ejemplo"
                                    formId="user"
                                    error={errors.user}
                                    img={User}
                                />
                                <InputComponent
                                    className="inputLoginContent"
                                    floatingLabel={labels.password}
                                    placeholder="*******"
                                    formId="password"
                                    type="password"
                                    trailingIcon="show"
                                    error={errors.password}
                                    img={Lock}
                                />
                                {/* <div className="terms-text-flex">
                                    <div className="centeredCheckbox-TCConfig">
                                        <SquareCheckBox
                                            checkId="reception24-7"
                                            labelClassName="Body3-12 "
                                            label={
                                                labels.acceptTermsLogin.label1
                                            }
                                            onClick={() => setAccept(!accept)}
                                            checked={accept}
                                        />
                                        <Text
                                            as="link"
                                            label={
                                                labels.acceptTermsLogin.label2
                                            }
                                            variant="termsStyleLogin"
                                            to="https://goolge.com"
                                        />
                                    </div>
                                </div> */}

                                <div className="login-button-container">
                                    <button
                                        type="submit"
                                        className={'button-login'}
                                    >
                                        <a className={'button-text-login'}>
                                            {labels.login}
                                        </a>
                                    </button>
                                    {/* <button className={'button-create'}>
                                <a className={'button-text-create'}>
                                    {labels.create}
                                </a>
                            </button> */}
                                </div>
                            </form>
                            {/* <div
                                onClick={handlePressForgotPassword}
                                className="bottomLinkStyle forget-pwd-container"
                            >
                                <Text
                                    as={link}
                                    to={routes.passwordRecovery}
                                    variant="subtitle1 noUnderline bottomLinksColor"
                                    label={labels.forgetPassword}
                                    fontSize={14}
                                    fontWeight={400}
                                    color={'#0E1726'}
                                />
                            </div> */}
                            {/*    <img
                                src={Help}
                                className="help-icon"
                                onClick={() =>
                                    window.open(
                                        'https://amipassmerchants.zendesk.com/hc/es-419'
                                    )
                                }
                            /> */}
                        </div>
                    </div>
                </div>
            </div>

            <ModalComponent
                modalStyle="loginModal"
                show={!!modalContentType}
                handleClose={handleCloseErrorModal}
            >
                <div className={'centeredIcon'}>
                    <img src={error} />
                </div>
                <IncorrectCredentials
                    text={
                        loginCount < 3
                            ? labels.incorrectCredentialsModal
                            : labels.accountBlockedModal
                    }
                    onClick={handleCloseErrorModal}
                />
            </ModalComponent>
        </>
    )
}
